import { useSortable } from "@dnd-kit/sortable";
import { Arguments } from "@dnd-kit/sortable/dist/hooks/useSortable";
import { faListOl } from "@fortawesome/free-solid-svg-icons/faListOl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { getLockedXAxisTransformStyle } from "@utils/dnd-util";
import { CSSProperties } from "react";
import styles from "./sortable-dnd-item.less";

type SortableDndItemProps = Arguments & {
    isActiveId: boolean;
    showDragAndDropIcon: boolean;
    children: React.ReactNode | Array<React.ReactNode>;
    additionalStyle: CSSProperties;
    activeIdStyle?: CSSProperties;
}

export const SortableDndItem = ({ showDragAndDropIcon, children, id, additionalStyle, isActiveId, activeIdStyle }: SortableDndItemProps) => {
    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: id });

    const style: CSSProperties = {
        userSelect: "none",
        transition,
        ...getLockedXAxisTransformStyle(transform),
        ... (isActiveId && activeIdStyle) ? activeIdStyle : additionalStyle,
    };

    return (
        <div
            data-rbd-drag-handle-draggable-id={`${id}`}
            ref={setNodeRef}
            style={style}
            {...attributes}
            {...listeners}>
            {showDragAndDropIcon ? (
                <span className={styles.labelInfo}>
                    <FontAwesomeIcon className={styles.listIcon} icon={faListOl} />
                    {children}
                </span>
            ) : (
                <>{children}</>
            )}

        </div>
    );
}